import { render, staticRenderFns } from "./EmergencyContact.vue?vue&type=template&id=b4416168&"
import script from "./EmergencyContact.vue?vue&type=script&lang=js&"
export * from "./EmergencyContact.vue?vue&type=script&lang=js&"
import style0 from "./EmergencyContact.vue?vue&type=style&index=0&id=b4416168&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports